import { useEffect, useState } from "react";

// bootstrap //
import Row from "react-bootstrap/Row";

import { Colors } from "_styles";

// redux
import {
  scoreCardData,
  setSelectedScore
} from "_redux/slices/analytics/reviews";
import { selectUserDb } from "_redux/slices/main-screen/user";
import { lookupIsLoading } from "_utils/statusUtil";
import { useDispatch, useSelector } from "react-redux";

function getDay(dayNumber) {
  switch (dayNumber) {
    case 0:
      return "Monday";
    case 1:
      return "Tuesday";
    case 2:
      return "Wednesday";
    case 3:
      return "Thursday";
    case 4:
      return "Friday";
    case 5:
      return "Saturday";
    case 6:
      return "Sunday";
    default:
      break;
  }
}

const RowTile = (props) => {
  const [showColor, setShowColor] = useState(false);
  const [color, setColor] = useState(null);

  useEffect(() => {
    if (
      props.realData &&
      props.realData[props.rowIndex] != undefined &&
      props.realData[props.rowIndex][props.columnIndex] != undefined
    ) {
      let val = props.realData[props.rowIndex][props.columnIndex]["sum"];

      if (val == 1) {
        setColor("red");
      } else if (val > 1 && val < 2) {
        setColor(Colors.HEATMAP_05);
      } else if (val > 2 && val < 3) {
        setColor(Colors.HEATMAP_04);
      } else if (val > 3 && val < 4) {
        setColor(Colors.HEATMAP_03);
      } else if (val > 3 && val <= 5) {
        setColor(Colors.HEATMAP_02);
      } else {
        setColor(Colors.HEATMAP_04);
      }

      setShowColor(true);
    }
  }, []);

  const handleClick = () => {
    if (props.realData && props.realData[props.rowIndex][props.columnIndex]) {
      let timeStamp = "am";

      if (props.columnIndex > 12) {
        timeStamp = "pm";
      }

      let selectedScore = {
        row: props.rowIndex,
        column: props.columnIndex,
        day: getDay(props.rowIndex),
        time: props.columnIndex.toString() + ":00" + timeStamp,
        data: props.realData[props.rowIndex][props.columnIndex],
      };

      props.dispatch(setSelectedScore(selectedScore));
    }
  };

  return (
    <div style={{ borderWidth: 1, padding: 2, textAlign: "center" }}>
      <div style={{ display: "flex", cursor: "pointer" }} onClick={handleClick}>
        {props.columnIndex == 0 && (
          <div style={{ width: 52 }}>
            <p style={{ fontSize: 8, marginBottom: -2, marginTop: 8 }}>
              {props.text}
            </p>
          </div>
        )}

        <div>
          {props.rowIndex == 0 && (
            <p style={{ fontSize: 8, marginBottom: -2 }}>{props.hour}</p>
          )}
          <div
            style={{
              width: 30,
              height: 30,
              borderWidth: 2.25,
              backgroundColor: showColor ? color : Colors.HEATMAP_EMPTY,
              borderStyle: "solid",
              borderColor: "white",
            }}
          ></div>
        </div>
      </div>
    </div>
  );
};

const CustomHeatMap = (props) => {
  const rowArray = Array.from({ length: 24 }, (_, index) => `${index}:00`);
  const columnArray = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ];

  // redux
  const dispatch = useDispatch();
  const dbUser = useSelector(selectUserDb);
  const realData = useSelector(scoreCardData);
  const realDataIsLoading = useSelector((state) =>
    lookupIsLoading(state.reviews.statusObj, ["getScoreCard"])
  );

  return realDataIsLoading ? (
    <Row className="justify-content-md-center mt-3">
      {/* <CustomSpinner /> */}
    </Row>
  ) : (
    <div>
      {columnArray.map((string, rowIndex) => (
        <div style={{ display: "flex" }}>
          {rowArray.map((hour, columnIndex) => (
            <RowTile
              hour={hour}
              columnIndex={columnIndex}
              text={string}
              rowIndex={rowIndex}
              dispatch={dispatch}
              dbUser={dbUser}
              realData={realData}
            />
          ))}
        </div>
      ))}
    </div>
  );
};

export default CustomHeatMap;
